<div class="card campanha-pipeline-card-info campanha-pipeline-card-info-vigencia"
    [class.campanha-pipeline-card-info-vigencia-nao-confirmada]="isNaoConfirmada"
    [class.campanha-pipeline-card-info-vigencia-em-analise]="isEmAnalise"
    [class.campanha-pipeline-card-info-vigencia-em-andamento]="isEmAndamento"
    [class.campanha-pipeline-card-info-vigencia-em-revisao]="isEmRevisao"
    [class.campanha-pipeline-card-info-vigencia-encerrada]="isEncerrada"
    [class.campanha-pipeline-card-info-vigencia-reprovada]="isReprovada">
    <div class="card-header">
        <h6 class="card-title">
            Vigência
        </h6>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush">
            <!-- Sob Demanda -->
            <li class="list-group-item" *ngIf="sobDemandaPacoteCampanha">
                <span class="list-group-item-value">
                    <sgt-sob-demanda-label
                        [sobDemanda]="sobDemandaPacoteCampanha"
                        label="Campanha Sob Demanda"
                        fontSize="10px">
                    </sgt-sob-demanda-label>
                </span>
            </li>         
            
            <!-- Recorrente -->
            <li class="list-group-item" *ngIf="!sobDemandaPacoteCampanha && vigenciaRecorrente">
                <span class="list-group-item-value">
                    <i class="fas fa-infinity"></i> Recorrente
                </span>
            </li>   

            <!-- Datas Vigência -->
            <li class="list-group-item">
                <span class="list-group-item-title" *ngIf="quantidadeDiasVigencia" title="Quantidade Dias Vigência">
                    {{quantidadeDiasVigencia}} dia(s)
                </span>

                <span class="list-group-item-values">
                    <span class="list-group-item-value" *ngIf="dataInicioAndamento" title="Data de início da campanha">
                        <i class="far fa-calendar"></i> {{dataInicioAndamento | date: 'dd/MM/yyyy HH:mm'}}
                    </span>

                    <span class="list-group-item-value" *ngIf="!dataTerminoAndamento && dataTerminoVigencia" title="Data prevista para o término da campanha">
                        <i class="fas fa-flag-checkered"></i> {{dataTerminoVigencia | date: 'dd/MM/yyyy'}}
                    </span>                    

                    <span class="list-group-item-value" *ngIf="dataTerminoAndamento" title="Data de término da campanha">
                        <i class="far fa-calendar-check"></i> {{dataTerminoAndamento | date: 'dd/MM/yyyy HH:mm'}}
                    </span>
                </span>
            </li>  
        </ul>
    </div>
</div>